import React from 'react';
import {Typography} from "@mui/material";
import LoggedLayout from "../../component/LoggedLayout";

 const CharacterView = () => {
    return (
        <LoggedLayout>
            <Typography>Welcome view</Typography>
        </LoggedLayout>
    )
}

export default CharacterView